export default __webpack_public_path__ + "static/media/Ironman_03.37527069.png";